import * as React from 'react';
import debounce from 'lodash/debounce';
import { FormControl } from '@common/components/form-control';
import cx from 'classnames';

import './Search.styles.scss';

export class Search extends React.Component {
    searchInputRef = React.createRef();

    constructor(props) {
        super(props);

        this.debouncedSearch = debounce(this.search, props.liveSearchDelay || 500);

        this.state = {
            value: props.value || ''
        };
    }

    search = () => {
        const value = this.searchInputRef.current?.value || '';
        this.props.onSearch?.({ searchKeyword: value });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.search();
    };

    handleChange = (e) => {
        const value = e.target.value;
        this.setState({ value });

        if (this.props.withLiveSearch) {
            this.debouncedSearch();
        }
    };

    render() {
        const { className, placeholder = 'Search', style, id, iconProps, autoFocus, classes } = this.props;

        return (
            <div className={cx('Search', className)} style={style}>
                <form className={cx('Search__form', classes?.searchForm)} onSubmit={this.handleSubmit}>
                    <i {...iconProps} className="fa fa-search Search__icon" onClick={this.search} />
                    <FormControl
                        id={id}
                        autoFocus={autoFocus}
                        placeholder={placeholder}
                        inputRef={this.searchInputRef}
                        className="Search__form__input"
                        type="text"
                        value={this.state.value}
                        onChange={this.handleChange}
                    />
                </form>
            </div>
        );
    }
}